<template>
  <div class="bg-white layout dashboard__layout " :class="wrapperDynamicClass">
    <div v-if="allowCustom" class="layout__delete d-flex justify-content-center align-items-center border-radius clickable" :class="deleteDynamicClass">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.7235 3.35706L9.99935 9.08118L4.27522 3.35706C4.02148 3.10331 3.61007 3.10331 3.35633 3.35706C3.10258 3.6108 3.10258 4.02221 3.35633 4.27595L9.08045 10.0001L3.35633 15.7242C3.10258 15.978 3.10258 16.3894 3.35633 16.6431C3.61007 16.8968 4.02148 16.8969 4.27522 16.6431L9.99935 10.919L15.7235 16.6431C15.9772 16.8969 16.3886 16.8969 16.6424 16.6431C16.8961 16.3894 16.8961 15.978 16.6424 15.7242L10.9182 10.0001L16.6424 4.27596C16.8961 4.02221 16.8961 3.6108 16.6424 3.35706C16.3886 3.10331 15.9772 3.10331 15.7235 3.35706Z" fill="#40444F" />
      </svg>
    </div>
    <template v-if="hasHeader">
      <slot name="header" :class="headerDynamicClass"></slot>
    </template>
    <template v-else-if="!layoutEmpty">
      <div class="d-flex justify-content-between align-items-center" :class="headerDynamicClass">
        <div class="layout__loading skeleton-light-grey-200" v-if="loading"></div>
        <h4 class="heading-h5-16-medium text-light-high" v-else>
          {{ sectionTitle }}
        </h4>
        <template v-if="!allowCustom">
          <template v-if="hasHeaderAction">
            <div class="layout__page-btn" v-if="loading">
              <div class="layout__loading-page skeleton-light-grey-200"></div>
            </div>
            <slot v-else name="headerAction"></slot>
          </template>
        </template>
      </div>
    </template>
    <div class="seperator-line" v-if="sectionTitle && separatorLine"></div>
    <div :class="containerDynamicClass">
      <div class="layout__opacity" v-if="allowCustom">&nbsp;</div>
      <slot></slot>
    </div>
    <div class="row bg-light1 align-items-center layout__actions" v-if="allowCustom">
      <div class="col-6 d-flex">
        <div class="flex-grow-1 d-flex align-items-center justify-content-center layout__actions-btn">
          <svg class="icon" width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.32071 14.4V16H5.68003V14.4H7.32071V3.064L11.8346 7.464L13 6.336L6.5 0L0 6.336L1.1654 7.464L5.67929 3.064V14.4H7.32071Z" fill="#1E232F" />
          </svg>

          <span class="body-14-medium ml-1 text">Move up</span>
        </div>
        <div class="vertical-line">&nbsp;</div>
      </div>
      <div class="col-6 d-flex align-items-center justify-content-center layout__actions-btn">
        <svg class="icon" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.17929 1.6V0L7.81997 0V1.6L6.17929 1.6L6.17929 12.936L1.6654 8.536L0.5 9.664L7 16L13.5 9.664L12.3346 8.536L7.82071 12.936L7.82071 1.6L6.17929 1.6Z" fill="black" />
        </svg>

        <span class="body-14-medium ml-1 text">Move down</span>
      </div>
    </div>
    <div v-if="hasFooter && !loading" :class="footerDynamicClass">
      <slot name="footer"></slot>
    </div>
    <div v-if="isPaging && !loading" :class="footerDynamicClass">
      <div class="d-flex justify-content-between align-items-center">
        <div class="pagination d-flex align-items-center">
          <div 
            class="clickable d-flex justify-content-center align-items-center layout__page-slider previous" 
            :class="previousDynamicClass" 
            :disabled="disablePrevious" 
            @click="clickPrevious" 
            v-popover:tooltip.top="'Previous'"
          >
            <div class="layout__loading-page skeleton-light-grey-200" v-if="loading"></div>
            <i class="icon icon-arrow-left" v-else></i>
          </div>
          <div 
            class="pagination-bullets layout__page-slider clickable d-flex align-items-center justify-content-center" 
            v-for="index in totalPages" 
            :key="`dot-${index}`" 
            @click="moveToPage(index)"
            v-popover:tooltip.top="`Page ${index}`"
          >
            <span class="swiper-pagination-bullet layout__page-dot" :class="getDotDynamicClass(index)"></span>
          </div>
          <div 
            class="d-flex clickable justify-content-center align-items-center layout__page-slider next" 
            :class="nextDynamicClass" 
            :disabled="disableNext" 
            @click="clickNext"
            v-popover:tooltip.top="'Next'"
          >
            <div class="layout__loading-page skeleton-light-grey-200" v-if="loading"></div>
            <i class="icon icon-arrow-right" v-else></i>
          </div>
        </div>
        <slot name="pagingAction"></slot>
      </div>
    </div>
  </div>
</template>

<script>
// Pending: Move Widget on Page
// import { mapGetters } from "vuex";

export default {
  name: "SectionLayout",
  props: {
    sectionTitle: {
      type: String,
      default: ""
    },
    isPaging: {
      type: Boolean,
      default: false
    },
    totalPages: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 0
    },
    customClass: {
      type: String,
      default: "p-2"
    },
    disabledCustom: {
      type: Boolean,
      default: false
    },
    layoutEmpty: {
      type: Boolean,
      default: false
    },
    separatorLine: {
      type: Boolean,
      default: true
    },
    sectionKey: {
      type: String,
      default: ""
    },
    footerClass: {
      type: String,
      default: "mt-1"
    },
    headerClass: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    openCustom: false
  }),
  computed: {
    // Pending: Move Widget on Page
    // ...mapGetters("dashboard", {
    //   openCustom: "openCustom"
    // }),
    allowCustom() {
      return !this.disabledCustom && this.openCustom;
    },
    hasHeader() {
      return !!this.$slots["header"] || !!this.$scopedSlots["header"];
    },
    hasHeaderAction() {
      return !!this.$slots["headerAction"] || !!this.$scopedSlots["headerAction"];
    },
    hasFooter() {
      return !!this.$slots["footer"] || !!this.$scopedSlots["footer"];
    },
    disablePrevious() {
      return this.currentPage === 1;
    },
    disableNext() {
      return this.currentPage === this.totalPages;
    },
    previousDynamicClass() {
      return {
        disabled: this.disablePrevious
      };
    },
    nextDynamicClass() {
      return {
        disabled: this.disableNext
      };
    },
    containerDynamicClass() {
      return {
        "mt-2": !this.layoutEmpty,
        layout__default: this.allowCustom
      };
    },
    deleteDynamicClass() {
      return { "layout-empty": this.layoutEmpty };
    },
    wrapperDynamicClass() {
      const classList = [this.customClass];
      if (this.allowCustom) {
        classList.push("overflow-hidden");
      }
      return classList.join(" ");
    },
    footerDynamicClass() {
      const classList = [this.footerClass];
      return classList.join(" ");
    },
    headerDynamicClass() {
      const classList = [this.headerClass];
      return classList.join(" ");
    },
    titleDynamicClass() {
      return {
        "loading": this.loading,
      }
    }
  },
  methods: {
    getDotDynamicClass(index) {
      return {
        active: index == this.currentPage
      };
    },
    moveToPage(index) {
      if (index < 1) {
        index = this.totalPages;
      }
      if (index > this.totalPages) {
        index = 1;
      }
      this.$emit("paging", index);
    },
    clickPrevious() {
      if (!this.disablePrevious) {
        this.moveToPage(this.currentPage - 1);
      }
    },
    clickNext() {
      if (!this.disableNext) {
        this.moveToPage(this.currentPage + 1);
      }
    }
  }
};
</script>

<style lang="scss">
$delete-size: 32px;
$delete-position: 16px;
$page-btn-size: 24px;
$dot-page: 4px;

.layout {
  &__delete {
    position: absolute;
    top: $delete-position;
    right: $delete-position;
    height: $delete-size;
    width: $delete-size;
    z-index: 1;
    background-color: map-get($light-grey, "200");

    &.layout-empty {
      background-color: map-get($dark-blue, "300");
      path {
        fill: map-get($light-text, "low-contrast");
      }
    }
  }

  &__page {
    &-btn {
      width: $page-btn-size;
      height: $page-btn-size;
      border-radius: $radius;
      border: 1px solid map-get($light-grey, "300");
      background-color: $light1;

      &:not(.disabled):hover {
        border-color: map-get($dark-text-new, "high-contrast");
      }

      &.disabled {
        background-color: map-get($light-grey, "300");
        cursor: not-allowed;

        & .icon {
          color: map-get($dark-text, "disabled");
        }
      }
    }

    &-slider {
      width: 24px;
      height: 24px;
      .icon {
        color: $textLightModeHigh !important;
      }
    }
    
    &-dot {
      width: $dot-page;
      height: $dot-page;
      background-color: $dark6;
      cursor: default;
      &.active {
        background-color: $textLightModeHigh;
      }
    }

  }

  &:hover {
    .layout__default {
      opacity: 0.3;
    }

    .layout__actions {
      bottom: 0;
    }
  }

  &__default {
    position: relative;
  }

  &__opacity {
    opacity: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
  }

  &__actions {
    left: 12px;
    bottom: -48px;
    z-index: 2;
    width: 100%;
    height: 48px;
    position: absolute;

    &-btn {
      cursor: pointer;

      .text {
        color: map-get($dark-text-new, "high-contrast");
      }

      &:not(.disabled):hover {
        .text {
          color: map-get($primary, "300");
        }

        .icon {
          path {
            fill: map-get($primary, "300");
          }
        }
      }

      &.disabled {
        .text {
          color: map-get($dark-text-new, "disabled");
        }

        .icon {
          path {
            fill: map-get($dark-text-new, "disabled");
          }
        }
      }
    }
  }

  &__loading {
    width: 120px;
    height: 16px;

    &-page {
      width: 100%;
      height: 100%;
    }
  }

  .vertical-line {
    width: 1px;
    height: 66.6667%;
    border-left: 1px solid map-get($light-grey, "400");
  }

  .seperator-line {
    height: 1px;
    background-color: $textDarkModeHigh;
    margin: 16px 0;
  }

  &.dashboard__layout {
    border-radius: 3px;
    margin-top: 24px;
    position: relative;

    &.no-shadow {
      box-shadow: none;
    }

    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
